import { cachingService, LocalLookupService } from "@ofqual/portal-core/core/dataAccess";
import { API_HOST_ORGS, API_HOST_QUALS, API_HOST_SEARCH, API_HOST_REFDATA, API_HOST_GUIDANCE } from "../config";
import { UnitService } from "./UnitService";
import exampleLookups from "./json/exampleLookups.json";
import { AwardingOrgSearchService } from "./AwardingOrgSearchService";
import { AwardingOrgService } from "./AwardingOrgService";
import { SectorSubjectAreaService } from "./SectorSubjectAreaService";
import { LevelsService } from "./LevelsService";
import { GuidanceService } from "./GuidanceService";


export const unitService = new UnitService(API_HOST_QUALS);

export const exampleLookupService = new LocalLookupService(exampleLookups);
export const aoServiceSearch = new AwardingOrgSearchService(API_HOST_SEARCH);
export const aoService = new AwardingOrgService(API_HOST_ORGS);
export const sectorSubjectService = new SectorSubjectAreaService(API_HOST_REFDATA);
export const levelsService = new LevelsService(API_HOST_REFDATA);
export const cachedLevelsService = cachingService(
  levelsService
);
export const guidanceService = new GuidanceService(API_HOST_GUIDANCE);
